import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Table, Form, Row, Badge, Dropdown } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import Pagination from "../components/Pagination";
import { TableLoaderRow, TableEmptyRow } from "../components/TableLoader";
import {
  blockUser,
  getUserList,
} from "../../services/UserServices/UserService";
import S3Image from "../components/S3Image";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import debounce from "lodash/debounce";

export default function GuestList(props) {
  const navigate = useNavigate();
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [loader, setLoader] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [jobId, setJobId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  //  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [sortBy,setSortBy]=useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);


  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  async function handleTableList() {
    setLoader(true);
    try {
      const res = await getUserList(currentPage, 10, search);
      setTableData(res?.data?.data?.users);
      setTotalItems(res?.data?.data.count);
    
      
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  }

  async function handleBlockComponent() {
    setActionLoading(true);
    try {
      await blockUser({ userId: jobId, isBlocked });
      handleTableList();
      setDeleteAccount(false);
      toast.success("User blocked successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setActionLoading(false);
    }
  }

  const handleTableListDebounced = useCallback(
    debounce(() => {
      handleTableList();
    }, 400),
    [search,currentPage]
  );


 
  // useEffect to trigger search whenever input changes
  useEffect(() => {
    handleTableListDebounced();

    // Cleanup debounce on unmount or next effect
    return () => handleTableListDebounced.cancel();
  }, [search, currentPage]);

  async function handleUnblockComponent(id) {
    setActionLoading(true);
    try {
      await blockUser({ userId: id, isBlocked: false });
      handleTableList();
      setDeleteAccount(false);
      toast.success("User unblocked successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setActionLoading(false);
    }
  }

  const totalPages = Math.ceil(totalItems / itemsPerPage);
 

  if (!!tableData && tableData?.length === 0 && !loader) {
    <div className="justify-content-center d-flex my-5 ">
      Sorry, Data Not Found!
    </div>;
  }
 

  console.log("BLOCK", isBlocked)
  

  return (
    <div className="qx-page">
      <PageTitle pageTitle="Guest List" subtitle="View and manage guest accounts" />

      <Card className="qx-filter-card border-0 shadow-none mb-4">
        <Row className="g-3 qx-filter-grid align-items-end">
          <Col lg={4} md={6} sm={12}>
            <Form.Group className="mb-0">
              <Form.Label>Search</Form.Label>
              <div className="qx-search-wrap">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name, phone-number"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                {search && (
                  <button
                    type="button"
                    onClick={() => setSearch("")}
                    className="qx-search-clear"
                    aria-label="Clear search"
                  >
                    ×
                  </button>
                )}
              </div>
            </Form.Group>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <Form.Group className="mb-0">
              <Form.Label>Sort By</Form.Label>
              <Form.Select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                <option value="">Default</option>
                <option value="name">Name</option>
                <option value="createdAt">Created At</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </Card>

      <Card className="qx-table-card">
        <Card.Body>
          <Table responsive>
            <thead>
              <tr>
                <th><strong>S.NO</strong></th>
                <th><strong>Name</strong></th>
                <th><strong>User Type</strong></th>
                <th><strong>Phone Number</strong></th>
                <th><strong>Created At</strong></th>
                <th><strong>Status</strong></th>
                <th><strong>Action</strong></th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <TableLoaderRow colSpan={7} />
              ) : !tableData || tableData.length === 0 ? (
                <TableEmptyRow colSpan={7} message="No guests found" />
              ) : (
                tableData.map((tension, index) => (
                  <tr key={tension?._id}>
                        <td>{index + 1 + currentPage * itemsPerPage}</td>
                    
                        <td>
                          <span className="w-space-no">
                            {" "}
                            {tension?.hostName ? tension?.hostName : "_"}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`w-space-no`}
                          >
                            {tension?.hostSide ? tension?.hostSide : "Bride"}
                          </span>
                        </td>
                        <td>
                          <span className="w-space-no">
                            {tension?.countryCode} {tension?.phoneNumber}
                          </span>
                        </td>
                        <td>
                          <span className="w-space-no">
                            {new Date(tension?.createdAt).toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              }
                            )}
                          </span>
                        </td>
                        <td>
                          {tension?.isBlocked ? (
                            <Badge bg="" className="badge-danger">
                              Blocked
                            </Badge>
                          ) : (
                            <Badge bg="" className="badge-success">
                              Enable
                            </Badge>
                          )}
                        </td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="info light"
                              className="qx-action-toggle"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  navigate(`/user-details/${tension._id}`, {
                                    state: { tension },
                                  });
                                  //  navigate(`/user-details/${tension._id}`)
                                }}
                              >
                                View
                              </Dropdown.Item>

                              {/* ✅ Block / Unblock Option */}
                              <Dropdown.Item
                                onClick={() => {
                                  if (tension?.isBlocked) {
                                    handleUnblockComponent(tension?._id);
                                    setIsBlocked(false);
                                  } else {

                                    setDeleteAccount(true);
                                    setJobId(tension?._id);
                                    setIsBlocked(true);
                                  }
                                }}
                              >
                                {tension?.isBlocked ? "Unblock" : "Block"}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                ))
              )}
            </tbody>
          </Table>

          {!loader && tableData?.length > 0 && (
            <Pagination
              pageCount={totalPages}
              pageValue={currentPage}
              setPage={setCurrentPage}
              total={totalItems}
              pageSize={itemsPerPage}
            />
          )}
        </Card.Body>
      </Card>
      <ConfirmationDeleteAccount
        show={deleteAccount}
        onHide={() => setDeleteAccount(false)}
        onDelete={handleBlockComponent}
        type="user"
      />
    </div>
  );
}




 